import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ThumbnailItem from '../svod/thumbnail-item';
import AssetDetailsDropdown from '../svod/asset-details-dropdown';
import PosterItem from '../svod/poster-item';
import thin_left_chevron from '../../assets/svod/buttons/thin-left-chevron.png';
import thin_right_chevron from '../../assets/svod/buttons/thin-right-chevron.png';
import { Link } from 'react-router-dom';
import { setSelectedAssetRow, setCuratedRow, setTargetAsset } from '../../redux/actions/SVOD';
import { EnvType } from "./constants";
import svodMessages from '../../locales/svod';
import appletvPlusThumbnail from '../../assets/included-appletv-thumbnail.jpeg';

import Logger from '../../functions/logging';

class LOLOMO extends React.Component {
	constructor(props) {
		super(props);
		this.viewAllButton = React.createRef();
		this.rowTitle = (this.props.label.split("_")[0] === "Poster") ? (this.props.label.split("_")[2]) : (this.props.label.split("_")[0]);

		let branding;
		let rowId;
		props.rowInformation.forEach((row) => {
			if (row.label === this.rowTitle) {
				branding = row.branding;
				rowId = row.id;
			}
		});

		this.state = {
			scrollPosition: 0,
			scrollButtons: true,
			timeIn: '',
			timeOut: '',
			hideRightScrollButton: false,

			branding,
			rowId,
		};

		this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
		this.handleItemsScroll = this.handleItemsScroll.bind(this);
		this.slideLeft = this.slideLeft.bind(this);
		this.slideRight = this.slideRight.bind(this);
		this.rowID = this.props.label.split("_")[1];
		this.mouseEnter = this.mouseEnter.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
		this.openSelectedAssetRowPage = this.openSelectedAssetRowPage.bind(this);
		this.isInViewport = this.isInViewport.bind(this);
		this.findTargetAsset = this.findTargetAsset.bind(this);
	}

	componentDidMount() {
		if (this.props.isCuratedRow) {
			this.props.setCuratedRow(this.props.label);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.timeOut !== this.state.timeOut) {
			if (this.state.timeOut - this.state.timeIn > 3000) {
				this.props.eventHandler({
					data: {
						event_type: "time_interacted_with",
						type: "row",
						action: "end_time",
						asset_id: this.rowID,
						start_time: this.state.timeIn,
						end_time: this.state.timeOut
					}
				});
			}
		}

		if (!prevProps.navigateToCuratedPage && this.props.navigateToCuratedPage) {
			if (this.props.isCuratedRow) {
				this.props.setSelectedAssetRow(this.props.label);
				let button = document.getElementById(`curated-link`);
				button.click();
			}
		}

		if (!this.props.targetAssetId && this.props.videos) {
			this.findTargetAsset();
		}
	}

	findTargetAsset() {
		const {
			videos,
			pathTracker,
			rowInformation
		} = this.props;

		let targetPaths;
		rowInformation.forEach((row) => {
			if (row.label === this.rowTitle) {
				targetPaths = row.paths;
			}
		});

		let videoIds = Object.keys(videos);
		videoIds.forEach((videoId) => {
			if (targetPaths && targetPaths[videoId]) {
				let possibleTargetPaths = targetPaths[videoId];
				possibleTargetPaths.forEach((conditions) => {
					if (conditions.length) {
						let selectedPaths = [];

						conditions.forEach((path_id) => {
							if (pathTracker && pathTracker.includes(path_id)) {
								selectedPaths.push(path_id);
							}
						});

						if (selectedPaths.length === conditions.length) {
							this.props.setTargetAsset(videoId);
						}
					}
				});
			}
		});
	}

	isInViewport(asset, scrollAmount, isElement) {
		let rect;
		if (isElement) {
			rect = asset.getBoundingClientRect();
		}
		else {
			rect = asset.current.getBoundingClientRect();
		}

		return (
			rect.top >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
			rect.left - scrollAmount + 150 >= 0 &&
			rect.right - scrollAmount <= (window.innerWidth || document.documentElement.clientWidth) + 125 /* or $(window).width() */
		);
	}

	handleThumbnailClick() {
		this.props.eventHandler({
			data: {
				event_type: "thumbnail_click",
				asset_name: "IWATV+",
				row_name: this.rowTitle,
				row_id: this.state.rowId,
				page_location: this.props.pageLocation || "home_page",
				time: Date.now()
			}
		});
	}

	handleItemsScroll() {
		let vidItems = document.getElementsByClassName(`videoItem-${this.props.label}`);
		let appleThumbnails = document.getElementsByClassName(`videoItem-${this.props.label} included-apple-tv-thumbnail`);
		document.documentElement.style.setProperty('--lolomo-scroll', `${this.state.scrollPosition}px`);

		for (let i = 0; i < appleThumbnails.length; i++) {
			appleThumbnails[i].style.transform = `translateX(${this.state.scrollPosition}px)`;
		}

		for (let i = 0; i < vidItems.length; i++) {
			vidItems[i].style.transform = `translateX(${this.state.scrollPosition}px`;
		}
	}

	slideLeft() {
		let scrollAmount = document.body.clientWidth - 100;
		let newPos = this.state.scrollPosition + scrollAmount;
		if (newPos >= 0) {
			newPos = 0;
		}

		let videoAssets = document.getElementsByClassName(`videoItem-${this.props.label}`);
		let inView = [];

		for (let asset of videoAssets) {
			if (this.isInViewport(asset, -scrollAmount, true)) {
				let assetId = asset.classList[0];
				inView.push(assetId);
			}
		}

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "scroll_click",
				row_name: this.rowTitle,
				row_id: this.state.rowId,
				direction: 'left',
				page_location: this.props.pageLocation || "home_page",
				assets_in_view: inView,
				time: Date.now()
			}
		});

		this.setState({ scrollPosition: newPos, hideRightScrollButton: false }, () => this.handleItemsScroll());
	}

	slideRight() {
		let lolomoWidth = document.getElementById(`slide-${this.props.label}`).scrollWidth;
		let scrollAmount = document.body.clientWidth - 100;
		let newPos = this.state.scrollPosition - scrollAmount;

		let videoAssets = document.getElementsByClassName(`videoItem-${this.props.label}`);
		let inView = [];

		for (let asset of videoAssets) {
			if (this.isInViewport(asset, scrollAmount, true)) {
				let assetId = asset.classList[0];
				inView.push(assetId);
			}
		}

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "scroll_click",
				row_name: this.rowTitle,
				row_id: this.state.rowId,
				direction: 'right',
				page_location: this.props.pageLocation || "home_page",
				assets_in_view: inView,
				time: Date.now()
			}
		});

		if (this.props.environment === EnvType.PEACOCK || this.props.environment === EnvType.APPLETV) {
			if (!this.isInViewport(this.viewAllButton, 0, false)) {
				this.setState({ scrollPosition: newPos }, () => this.handleItemsScroll());
			}
			else {
				this.setState({ hideRightScrollButton: true }, () => this.handleItemsScroll());
			}
		}
		else {
			if (newPos <= (-lolomoWidth + -scrollAmount + -(scrollAmount * .2))) {
				newPos = this.state.scrollPosition;
			}
			this.setState({ scrollPosition: newPos }, () => this.handleItemsScroll());
		}
	}

	mouseEnter() {
		this.setState({ timeIn: Date.now() });
	}

	mouseLeave() {
		this.setState({ timeOut: Date.now() });
	}

	openSelectedAssetRowPage() {
		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "view_all_click",
				row_name: this.rowTitle,
				row_id: this.state.rowId,
				page_location: this.props.pageLocation || "home_page",
				time: Date.now()
			}
		});

		this.props.setSelectedAssetRow(this.props.label);
	}

	render() {
		const {
			environment,
			videos,
			appletvVideos,
			rowInfoObject,
			disableThumbnails,
			fetchedGroup
		} = this.props;
		Logger.log(this.constructor.name, "render() LOLOMO", videos, rowInfoObject);

		const { svod_env } = fetchedGroup;
		let videoIds = Object.keys(videos);
		let poster_class = "";
		let videoItems;

		// Peacock only - hide target content from view in home-page. 
		if (environment === EnvType.PEACOCK
			&& svod_env
			&& svod_env.guided_experience
			&& svod_env.guided_experience.pathed_target_guide
		) {
			let filteredVideoIds = videoIds.filter(videoId => {
				let video = videos[videoId];
				return !video.focus_asset;
			});
			videoIds = filteredVideoIds;
		}

		if (this.props.label.split("_")[0] === "Poster" && environment === EnvType.NETFLIX) {
			poster_class = " poster-row";

			videoItems = videoIds.map((videoId, idx) => {
				return <PosterItem {...this.props} idx={idx} watchlist_video={false} video={videos[videoId]} label={this.props.label} key={`poster`} />;
			});
		}
		else {
			let isDisabled = false;
			if (this.props.row_type === "coming_soon"
				&& environment === EnvType.APPLETV
			) {
				isDisabled = true;
			}

			videoItems = videoIds.map((videoId, idx) => {
				const isAssetDisabled = videos[videoId] && videos[videoId].disabledAsset;
				return (
					<ThumbnailItem {...this.props}
						idx={idx}
						disabledAsset={isDisabled || isAssetDisabled}
						watchlist_video={false}
						videos={videos}
						video={videos[videoId]}
						label={this.props.label}
						page_location={this.props.pageLocation || "home_page"}
						key={`thumbnail`}
						source_asset_name={this.props.video && this.props.video.name}
						source_asset_id={this.props.video && this.props.video._id}
					/>
				);
			});
		}

		// this checks the row object from the main `row` array of the SVOD environment object
		// if the `appletv_plus` value is set to true, the "Included with AppleTV+" thumbnail is inserted to the front of the row
		if (environment === EnvType.APPLETV
			&& rowInfoObject
			&& rowInfoObject.appletv_plus
			&& !disableThumbnails
		) {
			videoItems.unshift(
				<span className={`videoItem-${rowInfoObject.label}_${this.props.rowInfoObject.id} included-apple-tv-thumbnail index-item thumbnail`}
					onClick={this.handleThumbnailClick}>
					<Link to="/study/included-with-apple-tv" id='includedAppleTVPage'>
						<span className={`dynamic-thumbnail thumbnail-container-appletv`}>
							<div className="image-container">
								<img className="thumbnail-pic opacity-100p" id={`included-with-appletv-img`} src={appletvPlusThumbnail} />
							</div>
						</span>
					</Link>
				</span>
			);
		}

		let assetDetailsDropdown = (this.props.activeDropdown.video === undefined) ? (
			<span></span>
		) : (
			(this.props.activeDropdown.label === this.props.label) ? (
				<AssetDetailsDropdown {...this.props} />
			) : (
				<span></span>
			)
		);

		let scrollButtons = (this.state.scrollButtons) ? (
			(this.state.scrollPosition === 0) ? (
				<span id="lolomo-scroll-arrow-container">
					<button className="scrollButton scrollRight" id={`slide-right-${this.props.label}`} onClick={this.slideRight} ><i className="fas fa-chevron-right"></i></button>
				</span>
			) : (
				<span id="lolomo-scroll-arrow-container">
					<button className="scrollButton scrollLeft" id={`slide-left-${this.props.label}`} onClick={this.slideLeft} ><i className="fas fa-chevron-left"></i></button>
					<button className="scrollButton scrollRight" id={`slide-right-${this.props.label}`} onClick={this.slideRight} ><i className="fas fa-chevron-right"></i></button>
				</span>
			)
		) : (
			<span id="lolomo-scroll-arrow-container"></span>
		);

		if (environment === EnvType.PEACOCK) {
			videoItems.push(
				<span className={`thumbnail-button index-item videoItem-${this.props.label} peacock-view-all-button`} id={`video-${this.props.label}-${videoItems.length}`} ref={this.viewAllButton} onClick={() => this.openSelectedAssetRowPage(this.props.label)}>
					<Link to="/study/curated" id={this.props.isCuratedRow ? "curated-link" : ""}>
						<p>{this.props.intl.formatMessage(svodMessages.view_all)}</p>
					</Link>
				</span>
			);
		}
		else if (environment === EnvType.APPLETV) {
			videoItems.push(
				<span className={`thumbnail-button videoItem-${this.props.label} appletv-lolomo-end`} id={`video-${this.props.label}-${videoItems.length}`} ref={this.viewAllButton}></span>
			);
		}

		let content = (environment) => {
			switch (environment) {
				case EnvType.NETFLIX:
					return (
						<div className={"slider" + poster_class} id={this.props.label.split("_")[1]}>
							<p className="lolomo-title">{this.rowTitle}</p>
							<div onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
								{scrollButtons}
								<div id={`slide-${this.props.label}`} className="category-list">
									{videoItems}
								</div>
								<span>
									{assetDetailsDropdown}
								</span>
							</div>
						</div>
					);

				case EnvType.AMAZON:
					return (
						<div className="slider" id={this.props.label.split("_")[1]}>
							<p className="lolomo-title">{this.rowTitle}</p>
							<div onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
								{scrollButtons}
								<div id={`slide-${this.props.label}`} className="category-list-amazon">
									{videoItems}
								</div>
								<span>
									{assetDetailsDropdown}
								</span>
							</div>
						</div>
					);

				case EnvType.PEACOCK:
					return (
						<div className="slider" id={this.props.label.split("_")[1]}>
							<p className="lolomo-title">
								<span className="mr-5">{this.rowTitle}</span>
							</p>
							<div id={this.props.isCuratedRow ? "curated-row" : ""} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
								{scrollButtons}
								<div id={`slide-${this.props.label}`} className="category-list">
									{videoItems}
								</div>
							</div>
						</div>
					);

				case EnvType.APPLETV:
					return (
						<div className="slider" id={this.props.label.split("_")[1]}>
							{!this.props.disableRowTitle && <p className="lolomo-title">{this.rowTitle}</p>}
							{this.props.description && <p className="lolomo-description">{this.props.description}</p>}

							<div className={`${this.props.row_type}-container`}
								onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>
								{this.state.scrollPosition != 0 && (
									<button className="scrollButton scrollLeft" id={`slide-left-${this.props.label}`} onClick={this.slideLeft} ><img src={thin_left_chevron} /></button>
								)}
								{!this.state.hideRightScrollButton && (
									<button className="scrollButton scrollRight" id={`slide-right-${this.props.label}`} onClick={this.slideRight} ><img src={thin_right_chevron} /></button>
								)}

								<div id={`slide-${this.props.label}`} className={`category-list`}>
									{videoItems}
								</div>
							</div>
						</div>
					);
			}
		};

		return (
			<header >
				{content(environment)}
			</header>
		);
	}
}


const mapStateToProps = (state) => ({
	selectedAssets: state.SVOD.selectedAssets,
	targetAssetId: state.SVOD.selectedAssets.targetAssetId,
});

const mapDispatchToProps = (dispatch) => ({
	setSelectedAssetRow: (rowLabel) => dispatch(setSelectedAssetRow(rowLabel)),
	setCuratedRow: (rowLabel) => dispatch(setCuratedRow(rowLabel)),
	setTargetAsset: (videos) => dispatch(setTargetAsset(videos)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LOLOMO));



// WEBPACK FOOTER //
// ./src/components/svod/lolomo.jsx